module.exports = __webpack_public_path__ + "static/media/linux.719c382d.png";